const __WEBPACK_NAMESPACE_OBJECT__ = require("@skjnldsv/sanitize-svg");